export function prepareVacanciesForTable(vacancies) {
  return vacancies.map((v) => (
    {
      ...v,
      interviewCount: v.counts?.interviews,
      candidatesCount: v.counts?.candidates,
      city: v.address?.city,
    }
  ));
}
